<template>
      <BTabs pills>
  
        <BTab id="general" active>
          <template #title>
            <FeatherIcon icon="HomeIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Datos generales</span>
          </template>
          <CoursesViewTabGeneral/>
        </BTab>
  
        <BTab v-if="$existsModule('Academy')" id="lessons" @click="showTabLessons=true">
          <template #title>
            <FeatherIcon icon="ClockIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Clases</span>
          </template>
          <CoursesViewTabLessons v-if="showTabLessons"/>
        </BTab>

        <BTab id="grades" @click="showTabGrades=true">
          <template #title>
            <FeatherIcon icon="ClipboardIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Notas</span>
          </template>
          <CoursesViewTabGrades v-if="showTabGrades"/>
        </BTab>

        <BTab id="evaluations" @click="showTabEvaluations=true">
          <template #title>
            <FeatherIcon icon="CalendarIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Evaluaciones</span>
          </template>
          <EvaluationsList v-if="showTabEvaluations" @re-render-notes="showTabGrades = false"/>
        </BTab>
  
      </BTabs>
  </template>
  <script>
  import { BTab, BTabs, BCard, BAlert, BLink, } from 'bootstrap-vue'
  import { ref, onUnmounted, provide, watch} from '@vue/composition-api'
  import store from '@/store'
  import CoursesViewTabGeneral from './CoursesViewTabGral'
  import CoursesViewTabLessons from './CoursesViewTabLessons'
  import CoursesViewTabGrades from './CoursesViewTabGrades'
  import EvaluationsList from "../../evaluations/EvaluationsList"
  import dateUtils from '@/hooks/dateUtils' 
  import currency from '@/utils/currency'
  import popups from '@/hooks/popups'
  import ability from '@/libs/acl/ability'
  import axios from '@axios'
  import router from '@/router'

  export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, CoursesViewTabGeneral, CoursesViewTabLessons, CoursesViewTabGrades, EvaluationsList}, 
    setup() {

      const { formatCurrency } = currency()
      const { formatDate } = dateUtils()
      const { deletePopup } = popups();
      const course = ref(null)
      const termsCourse=ref(null)
      const cursoMensual=ref(null)
      const reRenderKey = ref(0)
      const showTabGrades = ref(false)
      const showTabLessons = ref(false)
      const showTabEvaluations = ref(false)
      
      axios.get(`courses/${router.currentRoute.params.id}`).then(response => {
        course.value = response.data.course
          course.value.tax=course.value.tax
          termsCourse.value=response.data.terms
          
          if (termsCourse.value.length==0) {
            cursoMensual.value=true
          } else {
            cursoMensual.value=false
          }          
        })

      provide('course', course)


      return {
        showTabGrades,
        showTabLessons,
        showTabEvaluations
      }
    },
  }
  </script>
  
  <style>
  
  </style>
  